import axios from 'axios'

function APIClient(config = {}) {
  const { baseURL } = config

  return axios.create({
    baseURL,
    withCredentials: true,
  })
}

export default APIClient
